<template>
  <base-container ref="container">
    <a-row ref="row" type="flex" class="menus">

      <a-button style="width:30vw;font-size: 16px;" :type="'templates' === curDemo ? 'primary' : 'info'"
        icon="file-search" @click="curDemo = 'templates'">
        模 板 中 心
      </a-button>
      <div style="margin-left: 20px" />
      <a-button-group>
        <div v-for="demo in demoList" :key="demo.name">
          <a-button :type="demo.name === curDemo ? 'primary' : 'info'" @click="curDemo = demo.name">
            {{ demo.title }}
          </a-button>
        </div>
      </a-button-group>
    </a-row>
    <div :style="{ height: comHeight + 'px' }">
      <component :is="curDemo" />

    </div>
  </base-container>
</template>

<script>

import printDesign from './demo/design/index'
import printCustom from './demo/custom/index'
import printTasks from './demo/tasks/index'
import printPanels from './demo/panels/index'
import templates from './demo/templates/index'

export default {
  name: 'App',
  components: { printDesign, printCustom, printTasks, printPanels, templates },
  data() {
    return {
      show: false,
      containerHeight: undefined,
      rowHeight: undefined,
      comHeight: undefined,
      curDemo: '',
      demoList: [
        // {name: 'printDesign', title: '默认拖拽设计'},
        // {name: 'printCustom', title: '自定义设计'},
        // {name: 'printTasks', title: '队列/批量打印'},
        // {name: 'printPanels', title: '多面板设计'}
        { name: 'printCustom', title: '自定义设计' },
      ]
    }
  },
  created() {
    this.curDemo = 'templates'
  },
  mounted() {
    this.containerHeight = this.$refs.container.$el.clientHeight;
    this.rowHeight = this.$refs.row.$el.clientHeight
    this.comHeight = this.containerHeight - this.rowHeight
  },
}
</script>

<style lang="less">
.logos {
  padding: 6px 24px;
  display: flex;
  justify-content: center;
  align-self: center;

  img {
    height: 40px;
    width: 40px;
  }
}

.menus {
  padding: 10px 24px;
}

// hiprint 拖拽图片
.hiprint-printElement-image-content {
  img {
    content: url("./assets/logo.png");
  }
}

// 修改 页眉/页脚线 样式
.hiprint-headerLine,
.hiprint-footerLine {
  border-color: red !important;
}

.hiprint-headerLine:hover,
.hiprint-footerLine:hover {
  border-top: 3px dashed red !important;
}

.hiprint-headerLine:hover:before {
  content: "页眉线";
  left: calc(50% - 18px);
  position: relative;
  background: #FFFF;
  top: -12px;
  color: red;
  font-size: 12px;
}

.hiprint-footerLine:hover:before {
  content: "页脚线";
  left: calc(50% - 18px);
  position: relative;
  color: red;
  background: #FFFF;
  top: -12px;
  font-size: 12px;
}

.artisan-tab-pane {
  overflow: auto !important
}
</style>
